module.exports = __webpack_public_path__ + "static/hero-bg-image-34519e417f0cd57ba7f6648fa1369aec.jpg";